// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"2118c9de","455":"6f1cdaa6","488":"a4630719","977":"a42a78c6"}[chunkId] + ".chunk.js";
};